<div class="w-full py-3 px-4">
    <!-- create user Title Section -->
    <!-- <div class="md:flex items-center justify-between mb-4">
        <div class="flex items-center justify-start gap-1 lg:gap-2 mb-3 lg:mb-0">
            <svg class="size-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <mask id="mask0_848_1764" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24"
                    height="24">
                    <rect width="24" height="24" fill="#C19725" />
                </mask>
                <g mask="url(#mask0_848_1764)">
                    <path d="M16 22L6 12L16 2L17.775 3.775L9.55 12L17.775 20.225L16 22Z" fill="#C19725" />
                </g>
            </svg>
            <img class="size-6 sm:size-8 lg:size-10" src="/assets/images/user/create-user.png" alt="user">
            <span class="font-semibold text-sm sm:text-base lg:text-xl text-444">Staff Dashboard - Chetan Patil - Sales Team</span>
        </div>
    </div>
    <div class="overflow-x-auto whitespace-nowrap scrollbar-hide md:overflow-x-visible">
        <div class="min-w-max flex justify-end items-center gap-4">
            <div class="w-full flex justify-start items-center">
                <a routerLink="/rm-portal/home" routerLinkActive="bg-c19725 text-white font-medium outline-c19725 hover:bg-c19725 hover:text-white"
                    [routerLinkActiveOptions]="{ exact: false }"
                    class="flex-1 px-4 py-2 rounded-tl-[5px] rounded-bl-[5px] border-[0.50px] border-[#D9D9D9] flex justify-center items-center text-[#898989] text-sm sm:text-sm lg:text-base hover:bg-[#f6f1cb] hover:text-black">
                    Home
                </a>
    
                <a routerLink="sell-customer" routerLinkActive="bg-c19725 text-white font-medium outline-c19725 hover:bg-c19725 hover:text-white"
                    class="flex-1 px-4 py-2 border-[0.50px] border-[#D9D9D9] flex justify-center items-center text-[#898989] text-sm sm:text-sm lg:text-base hover:bg-[#f6f1cb] hover:text-black">
                    Sell
                </a>
    
                <div class="relative group flex-1">
                    <button routerLinkActive="bg-c19725 text-white font-medium outline-c19725 hover:bg-c19725 hover:text-white"
                        class="w-full px-4 py-2 border-[0.50px] border-[#D9D9D9] flex justify-center items-center gap-1
                               text-[#898989] text-sm sm:text-sm lg:text-base hover:bg-[#f6f1cb] hover:text-black">
                        Stock
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                                  d="M19 9l-7 7-7-7"/>
                        </svg>
                    </button> -->
                
                    <!-- Dropdown -->
                    <!-- <div 
                        class="absolute left-0 top-full w-full bg-white border border-gray-200 shadow-md rounded-b-md 
                               opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
                
                        <a routerLink="/rm-portal/new-stock"
                           class="block px-4 py-2 hover:bg-[#f6f1cb] text-sm text-[#555]">
                            New Stock
                        </a>
                    
                        <a routerLink="/stock/available"
                           class="block px-4 py-2 hover:bg-[#f6f1cb] text-sm text-[#555]">
                            Available Stock
                        </a> -->
                    
                        <!-- <a routerLink="/stock/total"
                           class="block px-4 py-2 hover:bg-[#f6f1cb] text-sm text-[#555]">
                            Total Stock
                        </a> -->
                    
                        <!-- <a routerLink="/stock/submitted"
                           class="block px-4 py-2 hover:bg-[#f6f1cb] text-sm text-[#555]">
                            Submitted Stock
                        </a>
                    
                        <a routerLink="/rm-portal/sold-stock"
                           class="block px-4 py-2 hover:bg-[#f6f1cb] text-sm text-[#555]">
                            Sold Stock
                        </a>
                    </div>
                </div> -->

                <!-- <a routerLink="/rm-portal/sales-history" routerLinkActive="bg-c19725 text-white font-medium outline-c19725 hover:bg-c19725 hover:text-white"
                    class="flex-1 px-4 py-2 border-[0.50px] border-[#D9D9D9] flex justify-center items-center text-[#898989] text-sm sm:text-sm lg:text-base hover:bg-[#f6f1cb] hover:text-black">
                    Sales
                </a>
    
                <a routerLink="/rm-portal/udhar" routerLinkActive="bg-c19725 text-white font-medium outline-c19725 hover:bg-c19725 hover:text-white"
                    class="flex-1 px-4 py-2 border-[0.50px] border-[#D9D9D9] flex justify-center items-center text-[#898989] text-sm sm:text-sm lg:text-base hover:bg-[#f6f1cb] hover:text-black">
                    Udhar
                </a>
    
                <div class="relative group flex-1">
                    <button 
                        class="w-full px-4 py-2 border-[0.50px] border-[#D9D9D9] flex justify-center items-center gap-1
                               text-[#898989] text-sm sm:text-sm lg:text-base hover:bg-[#f6f1cb] hover:text-black">
                        Accounts
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                                  d="M19 9l-7 7-7-7"/>
                        </svg>
                    </button> -->
                
                    <!-- Dropdown -->
                    <!-- <div 
                        class="absolute left-0 top-full w-full bg-white border border-gray-200 shadow-md rounded-b-md 
                               opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
                
                        <a routerLink="/rm-portal/incentive"
                           class="block px-4 py-2 hover:bg-[#f6f1cb] text-sm text-[#555]">
                            Incentives
                        </a>
                    
                        <a routerLink="/rm-portal/expense"
                           class="block px-4 py-2 hover:bg-[#f6f1cb] text-sm text-[#555]">
                            Expense
                        </a>
                    
                        <a routerLink="/rm-portal/assets"
                           class="block px-4 py-2 hover:bg-[#f6f1cb] text-sm text-[#555]">
                            Assets
                        </a>
                    </div>
                </div> -->

                <!-- <a routerLink="/rm-portal/add-customer" routerLinkActive="bg-c19725 text-white font-medium outline-c19725 hover:bg-c19725 hover:text-white"
                    class="flex-1 px-4 py-2 rounded-tr-[5px] rounded-br-[5px] border-[0.50px] border-[#D9D9D9] flex justify-center items-center text-[#898989] text-sm sm:text-sm lg:text-base hover:bg-[#f6f1cb] hover:text-black">
                    Customer List
                </a> -->
            <!-- </div>
        </div>
    </div> -->
    <div class="mt-4">
      <router-outlet/>
    </div>
</div>